
import { SERVER_PATH } from "../../config/env";
import { errorToaster, successToaster } from "./../../utils/index";
import apiClient from "../../utils/api";

// google auth client id
// export const clienId =
//   "541441021566-lmeq5iub6vvrd78bgnjbmr8gershnu0p.apps.googleusercontent.com";

// sivamfarms
export const clienId =
"385557212949-6u0285q12siram8gtosrspotn7bf979i.apps.googleusercontent.com"; //->chakara
  // "765836124688-qpovdfu1me0rupq6iv7o7hulnbrm6llt.apps.googleusercontent.com";
  // "65263119192-itch9gpjb9ie1i0o72qs8um7tlkjliu4.apps.googleusercontent.com";

// google auth success
export const onSuccess = async (data) => {
  const code = await apiClient
    .post(`post/user.php`, {
      user_id: data.email,
      user_name: data.name,
      address: "0",
      mobile_no: "0",
      avatar: data.picture,
      pincode: "0",
      status: "0",
      state: "0",
      no_purchases: "0",
      total_costof_purchases: "0",
    })
    .then((res) => {
      return res.status;
    });
  successToaster({ msg: "Login Successful" });
  return code;
};

// google auth failure
export const onFailure = (res) => {
  errorToaster({ msg: "Somthing went wrong" });
};

// google auth logout
export const onLogoutSuccess = () => {
  successToaster({ msg: "Logout Successful" });
};
